/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteRouteImport } from './routes/login/route'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppOrganizationSlugIndexRouteImport } from './routes/app/$organizationSlug/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminProjectsIndexRouteImport } from './routes/admin/projects/index'
import { Route as AdminOrgsIndexRouteImport } from './routes/admin/orgs/index'
import { Route as AppOrganizationSlugSettingsRouteImport } from './routes/app/$organizationSlug/settings'
import { Route as AppOrganizationSlugProjectSlugIndexRouteImport } from './routes/app/$organizationSlug/$projectSlug/index'
import { Route as AppOrganizationSlugProjectSlugSettingsRouteImport } from './routes/app/$organizationSlug/$projectSlug/settings'
import { Route as AppOrganizationSlugProjectSlugLanguageKeyIndexRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/index'
import { Route as AppOrganizationSlugProjectSlugLanguageKeySettingsRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/settings'
import { Route as AppOrganizationSlugProjectSlugLanguageKeyTopicSlugIndexRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/index'
import { Route as AppOrganizationSlugProjectSlugLanguageKeyTopicSlugSettingsRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/settings'
import { Route as AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugIndexRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/index'
import { Route as AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugSettingsRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/settings'
import { Route as AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/route'
import { Route as AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdIndexRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/index'
import { Route as AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdMediaIndexRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/media/index'
import { Route as AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdGlossaryIndexRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/glossary/index'
import { Route as AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsIndexRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/index'
import { Route as AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdContentIndexRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/content/index'
import { Route as AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdCitationsIndexRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/citations/index'
import { Route as AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsExcursionIdIndexRouteImport } from './routes/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/$excursionId/index'

const LoginRouteRoute = LoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginRouteRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrganizationSlugIndexRoute =
  AppOrganizationSlugIndexRouteImport.update({
    id: '/$organizationSlug/',
    path: '/$organizationSlug/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminProjectsIndexRoute = AdminProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminOrgsIndexRoute = AdminOrgsIndexRouteImport.update({
  id: '/orgs/',
  path: '/orgs/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AppOrganizationSlugSettingsRoute =
  AppOrganizationSlugSettingsRouteImport.update({
    id: '/$organizationSlug/settings',
    path: '/$organizationSlug/settings',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppOrganizationSlugProjectSlugIndexRoute =
  AppOrganizationSlugProjectSlugIndexRouteImport.update({
    id: '/$organizationSlug/$projectSlug/',
    path: '/$organizationSlug/$projectSlug/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppOrganizationSlugProjectSlugSettingsRoute =
  AppOrganizationSlugProjectSlugSettingsRouteImport.update({
    id: '/$organizationSlug/$projectSlug/settings',
    path: '/$organizationSlug/$projectSlug/settings',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppOrganizationSlugProjectSlugLanguageKeyIndexRoute =
  AppOrganizationSlugProjectSlugLanguageKeyIndexRouteImport.update({
    id: '/$organizationSlug/$projectSlug/$languageKey/',
    path: '/$organizationSlug/$projectSlug/$languageKey/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppOrganizationSlugProjectSlugLanguageKeySettingsRoute =
  AppOrganizationSlugProjectSlugLanguageKeySettingsRouteImport.update({
    id: '/$organizationSlug/$projectSlug/$languageKey/settings',
    path: '/$organizationSlug/$projectSlug/$languageKey/settings',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugIndexRoute =
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugIndexRouteImport.update({
    id: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/',
    path: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugSettingsRoute =
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugSettingsRouteImport.update({
    id: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/settings',
    path: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/settings',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugIndexRoute =
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugIndexRouteImport.update(
    {
      id: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/',
      path: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/',
      getParentRoute: () => AppRouteRoute,
    } as any,
  )
const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugSettingsRoute =
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugSettingsRouteImport.update(
    {
      id: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/settings',
      path: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/settings',
      getParentRoute: () => AppRouteRoute,
    } as any,
  )
const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute =
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRouteImport.update(
    {
      id: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId',
      path: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId',
      getParentRoute: () => AppRouteRoute,
    } as any,
  )
const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdIndexRoute =
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute,
    } as any,
  )
const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdMediaIndexRoute =
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdMediaIndexRouteImport.update(
    {
      id: '/media/',
      path: '/media/',
      getParentRoute: () =>
        AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute,
    } as any,
  )
const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdGlossaryIndexRoute =
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdGlossaryIndexRouteImport.update(
    {
      id: '/glossary/',
      path: '/glossary/',
      getParentRoute: () =>
        AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute,
    } as any,
  )
const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsIndexRoute =
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsIndexRouteImport.update(
    {
      id: '/excursions/',
      path: '/excursions/',
      getParentRoute: () =>
        AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute,
    } as any,
  )
const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdContentIndexRoute =
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdContentIndexRouteImport.update(
    {
      id: '/content/',
      path: '/content/',
      getParentRoute: () =>
        AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute,
    } as any,
  )
const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdCitationsIndexRoute =
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdCitationsIndexRouteImport.update(
    {
      id: '/citations/',
      path: '/citations/',
      getParentRoute: () =>
        AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute,
    } as any,
  )
const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsExcursionIdIndexRoute =
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsExcursionIdIndexRouteImport.update(
    {
      id: '/excursions/$excursionId/',
      path: '/excursions/$excursionId/',
      getParentRoute: () =>
        AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/app': typeof AppRouteRouteWithChildren
  '/login': typeof LoginRouteRouteWithChildren
  '/app/settings': typeof AppSettingsRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/login/': typeof LoginIndexRoute
  '/app/$organizationSlug/settings': typeof AppOrganizationSlugSettingsRoute
  '/admin/orgs/': typeof AdminOrgsIndexRoute
  '/admin/projects/': typeof AdminProjectsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/app/$organizationSlug/': typeof AppOrganizationSlugIndexRoute
  '/app/$organizationSlug/$projectSlug/settings': typeof AppOrganizationSlugProjectSlugSettingsRoute
  '/app/$organizationSlug/$projectSlug/': typeof AppOrganizationSlugProjectSlugIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/settings': typeof AppOrganizationSlugProjectSlugLanguageKeySettingsRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/': typeof AppOrganizationSlugProjectSlugLanguageKeyIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/settings': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugSettingsRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRouteWithChildren
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/settings': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugSettingsRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/citations/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdCitationsIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/content/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdContentIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/glossary/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdGlossaryIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/media/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdMediaIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/$excursionId/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsExcursionIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app/settings': typeof AppSettingsRoute
  '/admin': typeof AdminIndexRoute
  '/app': typeof AppIndexRoute
  '/login': typeof LoginIndexRoute
  '/app/$organizationSlug/settings': typeof AppOrganizationSlugSettingsRoute
  '/admin/orgs': typeof AdminOrgsIndexRoute
  '/admin/projects': typeof AdminProjectsIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/app/$organizationSlug': typeof AppOrganizationSlugIndexRoute
  '/app/$organizationSlug/$projectSlug/settings': typeof AppOrganizationSlugProjectSlugSettingsRoute
  '/app/$organizationSlug/$projectSlug': typeof AppOrganizationSlugProjectSlugIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/settings': typeof AppOrganizationSlugProjectSlugLanguageKeySettingsRoute
  '/app/$organizationSlug/$projectSlug/$languageKey': typeof AppOrganizationSlugProjectSlugLanguageKeyIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/settings': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugSettingsRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/settings': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugSettingsRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/citations': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdCitationsIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/content': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdContentIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/glossary': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdGlossaryIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/media': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdMediaIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/$excursionId': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsExcursionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/app': typeof AppRouteRouteWithChildren
  '/login': typeof LoginRouteRouteWithChildren
  '/app/settings': typeof AppSettingsRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/login/': typeof LoginIndexRoute
  '/app/$organizationSlug/settings': typeof AppOrganizationSlugSettingsRoute
  '/admin/orgs/': typeof AdminOrgsIndexRoute
  '/admin/projects/': typeof AdminProjectsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/app/$organizationSlug/': typeof AppOrganizationSlugIndexRoute
  '/app/$organizationSlug/$projectSlug/settings': typeof AppOrganizationSlugProjectSlugSettingsRoute
  '/app/$organizationSlug/$projectSlug/': typeof AppOrganizationSlugProjectSlugIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/settings': typeof AppOrganizationSlugProjectSlugLanguageKeySettingsRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/': typeof AppOrganizationSlugProjectSlugLanguageKeyIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/settings': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugSettingsRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRouteWithChildren
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/settings': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugSettingsRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/citations/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdCitationsIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/content/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdContentIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/glossary/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdGlossaryIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/media/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdMediaIndexRoute
  '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/$excursionId/': typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsExcursionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/login'
    | '/app/settings'
    | '/admin/'
    | '/app/'
    | '/login/'
    | '/app/$organizationSlug/settings'
    | '/admin/orgs/'
    | '/admin/projects/'
    | '/admin/users/'
    | '/app/$organizationSlug/'
    | '/app/$organizationSlug/$projectSlug/settings'
    | '/app/$organizationSlug/$projectSlug/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/settings'
    | '/app/$organizationSlug/$projectSlug/$languageKey/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/settings'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/settings'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/citations/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/content/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/glossary/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/media/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/$excursionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app/settings'
    | '/admin'
    | '/app'
    | '/login'
    | '/app/$organizationSlug/settings'
    | '/admin/orgs'
    | '/admin/projects'
    | '/admin/users'
    | '/app/$organizationSlug'
    | '/app/$organizationSlug/$projectSlug/settings'
    | '/app/$organizationSlug/$projectSlug'
    | '/app/$organizationSlug/$projectSlug/$languageKey/settings'
    | '/app/$organizationSlug/$projectSlug/$languageKey'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/settings'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/settings'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/citations'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/content'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/glossary'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/media'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/$excursionId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/app'
    | '/login'
    | '/app/settings'
    | '/admin/'
    | '/app/'
    | '/login/'
    | '/app/$organizationSlug/settings'
    | '/admin/orgs/'
    | '/admin/projects/'
    | '/admin/users/'
    | '/app/$organizationSlug/'
    | '/app/$organizationSlug/$projectSlug/settings'
    | '/app/$organizationSlug/$projectSlug/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/settings'
    | '/app/$organizationSlug/$projectSlug/$languageKey/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/settings'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/settings'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/citations/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/content/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/glossary/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/media/'
    | '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/$excursionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  AppRouteRoute: typeof AppRouteRouteWithChildren
  LoginRouteRoute: typeof LoginRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/$organizationSlug/': {
      id: '/app/$organizationSlug/'
      path: '/$organizationSlug'
      fullPath: '/app/$organizationSlug/'
      preLoaderRoute: typeof AppOrganizationSlugIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/projects/': {
      id: '/admin/projects/'
      path: '/projects'
      fullPath: '/admin/projects/'
      preLoaderRoute: typeof AdminProjectsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/orgs/': {
      id: '/admin/orgs/'
      path: '/orgs'
      fullPath: '/admin/orgs/'
      preLoaderRoute: typeof AdminOrgsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/app/$organizationSlug/settings': {
      id: '/app/$organizationSlug/settings'
      path: '/$organizationSlug/settings'
      fullPath: '/app/$organizationSlug/settings'
      preLoaderRoute: typeof AppOrganizationSlugSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/': {
      id: '/app/$organizationSlug/$projectSlug/'
      path: '/$organizationSlug/$projectSlug'
      fullPath: '/app/$organizationSlug/$projectSlug/'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/settings': {
      id: '/app/$organizationSlug/$projectSlug/settings'
      path: '/$organizationSlug/$projectSlug/settings'
      fullPath: '/app/$organizationSlug/$projectSlug/settings'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/'
      path: '/$organizationSlug/$projectSlug/$languageKey'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/settings': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/settings'
      path: '/$organizationSlug/$projectSlug/$languageKey/settings'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/settings'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeySettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/'
      path: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/settings': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/settings'
      path: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/settings'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/settings'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/'
      path: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/settings': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/settings'
      path: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/settings'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/settings'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId'
      path: '/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/'
      path: '/'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdIndexRouteImport
      parentRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/media/': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/media/'
      path: '/media'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/media/'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdMediaIndexRouteImport
      parentRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/glossary/': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/glossary/'
      path: '/glossary'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/glossary/'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdGlossaryIndexRouteImport
      parentRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/'
      path: '/excursions'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsIndexRouteImport
      parentRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/content/': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/content/'
      path: '/content'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/content/'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdContentIndexRouteImport
      parentRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/citations/': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/citations/'
      path: '/citations'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/citations/'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdCitationsIndexRouteImport
      parentRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute
    }
    '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/$excursionId/': {
      id: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/$excursionId/'
      path: '/excursions/$excursionId'
      fullPath: '/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId/excursions/$excursionId/'
      preLoaderRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsExcursionIdIndexRouteImport
      parentRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
  AdminOrgsIndexRoute: typeof AdminOrgsIndexRoute
  AdminProjectsIndexRoute: typeof AdminProjectsIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
  AdminOrgsIndexRoute: AdminOrgsIndexRoute,
  AdminProjectsIndexRoute: AdminProjectsIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRouteChildren {
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdIndexRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdIndexRoute
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdCitationsIndexRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdCitationsIndexRoute
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdContentIndexRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdContentIndexRoute
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsIndexRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsIndexRoute
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdGlossaryIndexRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdGlossaryIndexRoute
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdMediaIndexRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdMediaIndexRoute
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsExcursionIdIndexRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsExcursionIdIndexRoute
}

const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRouteChildren: AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRouteChildren =
  {
    AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdIndexRoute:
      AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdIndexRoute,
    AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdCitationsIndexRoute:
      AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdCitationsIndexRoute,
    AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdContentIndexRoute:
      AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdContentIndexRoute,
    AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsIndexRoute:
      AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsIndexRoute,
    AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdGlossaryIndexRoute:
      AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdGlossaryIndexRoute,
    AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdMediaIndexRoute:
      AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdMediaIndexRoute,
    AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsExcursionIdIndexRoute:
      AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdExcursionsExcursionIdIndexRoute,
  }

const AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRouteWithChildren =
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute._addFileChildren(
    AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppOrganizationSlugSettingsRoute: typeof AppOrganizationSlugSettingsRoute
  AppOrganizationSlugIndexRoute: typeof AppOrganizationSlugIndexRoute
  AppOrganizationSlugProjectSlugSettingsRoute: typeof AppOrganizationSlugProjectSlugSettingsRoute
  AppOrganizationSlugProjectSlugIndexRoute: typeof AppOrganizationSlugProjectSlugIndexRoute
  AppOrganizationSlugProjectSlugLanguageKeySettingsRoute: typeof AppOrganizationSlugProjectSlugLanguageKeySettingsRoute
  AppOrganizationSlugProjectSlugLanguageKeyIndexRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyIndexRoute
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugSettingsRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugSettingsRoute
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugIndexRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugIndexRoute
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRouteWithChildren
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugSettingsRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugSettingsRoute
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugIndexRoute: typeof AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppOrganizationSlugSettingsRoute: AppOrganizationSlugSettingsRoute,
  AppOrganizationSlugIndexRoute: AppOrganizationSlugIndexRoute,
  AppOrganizationSlugProjectSlugSettingsRoute:
    AppOrganizationSlugProjectSlugSettingsRoute,
  AppOrganizationSlugProjectSlugIndexRoute:
    AppOrganizationSlugProjectSlugIndexRoute,
  AppOrganizationSlugProjectSlugLanguageKeySettingsRoute:
    AppOrganizationSlugProjectSlugLanguageKeySettingsRoute,
  AppOrganizationSlugProjectSlugLanguageKeyIndexRoute:
    AppOrganizationSlugProjectSlugLanguageKeyIndexRoute,
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugSettingsRoute:
    AppOrganizationSlugProjectSlugLanguageKeyTopicSlugSettingsRoute,
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugIndexRoute:
    AppOrganizationSlugProjectSlugLanguageKeyTopicSlugIndexRoute,
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRoute:
    AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugVersionIdRouteRouteWithChildren,
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugSettingsRoute:
    AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugSettingsRoute,
  AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugIndexRoute:
    AppOrganizationSlugProjectSlugLanguageKeyTopicSlugPageSlugIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface LoginRouteRouteChildren {
  LoginIndexRoute: typeof LoginIndexRoute
}

const LoginRouteRouteChildren: LoginRouteRouteChildren = {
  LoginIndexRoute: LoginIndexRoute,
}

const LoginRouteRouteWithChildren = LoginRouteRoute._addFileChildren(
  LoginRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  AppRouteRoute: AppRouteRouteWithChildren,
  LoginRouteRoute: LoginRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
